import { useAccountShops, activeShopOf } from "../shops/accountShopsStore";
import ProductShopSelector from "../shops/ProductShopSelector";
import React, { useState, useEffect, useRef } from "react"
import Layout from "../Layout/Layout";
import ProductPriceInput from "../pageInside/ProductPriceInput";
import { Link, useNavigate, useParams, useLocation, Navigate} from "react-router-dom";
import {getAddressById, isAuthenticated, addPubCategories, getElakayLang } from '../auth';
import { getCategoriesByID, getCategoriesByName } from "../auth/apiCategory";
import { createProduct, getUserProductPreview, updateProduct, getImages} from "../auth/apiProduct";
import ImagesLoading from "../pageInside/imagesLoadingAdd"
import { FaLongArrowAltLeft, FaAddressCard, FaCheckCircle, FaEdit} from "react-icons/fa";
import { MdDeleteForever, MdAddCircle} from "react-icons/md";
import Modal from 'react-bootstrap/Modal';
// import AlertPage from "../pageInside/alertPage";
import {GrClose} from "react-icons/gr";
import Loader from '../Layout/loader.gif'
import AddressSeller from '../Layout/imgs/Address-Seller.png'
import CategoriesFilter from '../Layout/imgs/Category-filter-no.png' 
import SellerPub from '../Layout/imgs/Sell_Pro_ch.png' 
import Seller_caribbean from '../Layout/imgs/Seller_caribbean.png' 
import {laguangeElakay} from "../pageInside/dataElakay"; 
import nodata from '../Layout/imgs/nodata0.png';
import CatSelected from "./categories/catSelected";
import CatSearch from "./categories/catSearch";
import ShippingTable from "../pageInside/shippingInfoCadUsa";
import SalesSimulation from "../pageInside/salesSimulation";
import Pages from './LanguagePage'
import {

    ContactUs,
    TermsConditions,
    ReturnAndRefundPolicy
} from '../pageInside/conditionTherm'
import SellerFilterEditor from "./editProduct/SellerFilterEditor";
import useSellerFilterEditor from "./editProduct/useSellerFilterEditor";
import { sellerCategoryId } from "./editProduct/useSellerCombinationRows";
import { isFinalSellerProductCategory } from "./categories/productCategoryRules";
import "./addProduct.css" 
import AlertPage from "../pageInside/alertPage";
import {decryptData}  from '../auth/elakayCryptage'
import ErrorAlert from "../pageInside/ErrorAlert";
import { elakayAutoText } from "../pageInside/dataElakay";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["addProduct"]?.[key] || fallback;

let prodLink = '?ppb=true'
let sellUrl = '/myshop'


function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const buildUrlWithSel = (data, type = "ic") => {
  const { pathname } = window.location;
  const url = new URL(window.location.href);
  const params = url.searchParams;

  // sel toujours présent
  params.set("sel", "true");

  const hasIp = params.has("ip");
  const hasIc = params.has("ic");

  // Cas 1 : aucun ip / ic
  if (!hasIp && !hasIc) {
    params.set(type, data._id);
    return `${pathname}?${params.toString()}`;
  }

  // Cas 2 : le type existe déjà → on remplace seulement
  if (params.has(type)) {
    params.set(type, data._id);
    return `${pathname}?${params.toString()}`;
  }

  // Cas 3 : un seul existe → on ajoute le second
  if ((hasIp && !hasIc) || (!hasIp && hasIc)) {
    params.set(type, data._id);
    return `${pathname}?${params.toString()}`;
  }

  // Cas 4 : les deux existent → on respecte l’ordre de clic
  const entries = [...params.entries()].filter(
    ([k]) => k === "ip" || k === "ic"
  );

  const primary = entries[0][0];
  const secondary = entries[1][0];

  // Si on modifie le primary → on supprime le secondary
  if (primary === type) {
    params.set(type, data._id);
    params.delete(secondary);
    return `${pathname}?${params.toString()}`;
  }

  // Si on modifie le secondary → primary reste
  if (secondary === type) {
    params.set(type, data._id);
    return `${pathname}?${params.toString()}`;
  }

  return `${pathname}?${params.toString()}`;
};


const Sell = (props) => {
    const {
        infoSource
        } = props
        __setElakayInfoSource(infoSource);

      const query = useQuery();
      const _idProdQuery = query.get("ip") || null;
    const _idCatQuery = query.get("ic") || null;
   
    let params = useParams()
    const {token} = isAuthenticated();

      const {obj} = getElakayLang();
                    const {code }= obj

    const [words, setWords] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [getMaxkey, setMaxkey] = useState('');

    const [showConditions, setConditions] = useState(false);
    const [catSelectedSearch, setcatSelectedSearch] = useState(false);
    const { data: accountShops } = useAccountShops();
    const managedShop = activeShopOf(accountShops, "seller");

    const [shopIds, setShopIds] = useState(undefined);
    const hasShopAddress = (shopIds?.length ? accountShops?.shops?.filter((s) => shopIds.includes(String(s._id))) : [managedShop]).some((s) => s?.address?.country);
    const [productForShops, setProductForShops] = useState(null);
    const [addressSelect, setAddressSelect] = useState(''); 
    const [categories, setCategories] = useState([])
    const [filters, setFilters] = useState([]);
    const [filterProducts, setFilterProducts] = useState([]);
    // Config d'affichage des variantes (style Square/Circle/Images, images
    // par valeur, etc.) -- toujours peuplé par loadProductsView (même
    // contrat que editProduct.jsx), mais plus RENDU ici : "Filter for
    // product View" (AddFilterProduct) a été retiré de Sell Your Product et
    // ne vit plus que dans Edit Product. Laissé en place (au lieu de
    // supprimer loadProductsView's setFilterSel/setImagesProd/
    // setItemFilValue calls) pour ne pas toucher à loadProductsView, une
    // fonction partagée par d'autres étapes de ce flow.
    const [filterSel, setFilterSel] = useState([]);
    const [ImagesProd, setImagesProd] = useState([]);
    const [itemFilValue, setItemFilValue] = useState({});
    // const [filProd, setFilProd] = useState({});
    const [items, setItems] = useState([]);
    // const [filterOne, setFilter] = useState()
    const [loading, setLoading] = useState(true); 
    const [search, setSearch] = useState([]);
    const [searchInput, setSearchInput] = useState('');
    const [shwoSimulationSales, setSimulationSales] = useState(false)
    const [showAlert, setShowAlert] = useState(false);
    const [categoryValidationError, setCategoryValidationError] = useState("");
    const [productValidationError, setProductValidationError] = useState("");
    const [getUrl, setGetUrl] = useState(sellUrl+prodLink)
     const divSelCatego = useRef(null);
     const divProduct = useRef(null);
     const wizardContentRef = useRef(null);
     const nameRef = useRef(null);
     const descriptionRef = useRef(null);
     const priceRef = useRef(null);
     const conditionRef = useRef(null);
     const addressSelectRef = useRef(null);
    const{
        userInfo = [],
        address = []
    } = infoSource

    const scrollToDiv = (ref) => {
            if (ref && ref.current) {
            ref.current.scrollIntoView({ behavior: 'smooth'});
            }
          };
    let navigate = useNavigate()
    const [parcel, setParcel] = useState({
        length: "",
        width: "",
        height: "",
        weight: ""
        })

    const {
        length,
        width,
        height,
        weight
    } = parcel;

let jsonValues = {
    name: "",
    description: "",
    costPrice: "",
    graphic: false,
    price: "",
    categoryID: [],
    categoriesID: [],
    catalogID:"",
    shipping: false,
    shippingPrice: "",
    quantity: "",
    condition:"",
    formData: "",
    selCategories: false,
    inpProduct: true,
    filtProduct: false,
    imgPreview: false,
    filterID:"",
    AcCat:"",
    AcInf:"",
    AcFilt:"",
    AcImg:"",
    productID: "",
    error: "",
    redirectToFilter: false,
    creatorDesign : false,
}
    const [values, setValues] = useState(jsonValues);
    const {
        name,
        description,
        costPrice,
        graphic,
        price,
        categoryID,
        categoriesID,
        catalogID,
        filterID,
        shipping,
        shippingPrice,
        condition,
        inpProduct,
        filtProduct,
        selCategories,
        imgPreview,
        AcCat,
        AcInf,
        AcFilt,
        AcImg,
        productID,
        error,
        createdProduct,
        redirectToFilter,
        creatorDesign 
    } = values;


    const filterEditor = useSellerFilterEditor({
      productId: productID || _idProdQuery,
      categoryId: sellerCategoryId(categories._id),
      filtersCategory: filters,
      filterProducts,
      infoSource,
      token,
      createExtras: { parcel },
      onSaved: (savedRows) => {
        setFilterProducts((previous) => [
          ...previous.filter((row) => sellerCategoryId(row.catID) !== sellerCategoryId(categories._id)),
          ...savedRows,
        ]);
      },
    });
    const continueToImages = async () => {
      if (filterEditor.savingFilterCombinations || !(productID || _idProdQuery)) return;
      setValues((previous) => ({ ...previous, inpProduct: false, filtProduct: true, imgPreview: false }));
      const savedRows = await filterEditor.saveFilterCombinations({ requireCombination: true });
      if (!savedRows) return;
      setValues((previous) => ({
        ...previous, inpProduct: false, filtProduct: false, imgPreview: true,
        AcCat: "active", AcInf: "active", AcFilt: "active", AcImg: "active", loading: false,
      }));
    };

    const category = '5ed4946fd2ba8812c20261a8'
 
    const elakayCategoryID = params.categoryId ? params.categoryId : category;

    const loadCategory = async (ID, laod = true, filt = {}, prod=[]) => {
  
        let CaId = ID ? ID : elakayCategoryID

                try {
                    await getCategoriesByID(CaId).then(data => {
                if (data.error) {
                    throw new Error("data Not Found")
                 } else {

                const isFinalCategory = isFinalSellerProductCategory(data.cartegory, data.items, data.filter);
                // Already in the URL (refresh / Back from Info): don't push a
                // duplicate history entry.
                isFinalCategory && String(_idCatQuery) !== String(data.cartegory?._id)
                  && navigate(buildUrlWithSel(data.cartegory, "ic"))
                setFilters(data.filter)
                setCategories(data.cartegory)
                setItems(data.items)
               _idProdQuery === null && laod && isFinalCategory && setValues((previous) => ({
                 ...previous,
                 selCategories: true,
                 inpProduct: true,
                 filtProduct: false,
                 imgPreview: false,
                 AcCat: "active",
                 AcInf: "active",
                 AcFilt: "",
                 AcImg: "",
               }))
                setCategoryValidationError("")
                setLoading(false)
                // navigate(sellUrl)
                setSearchInput('');
                setSearch([]);
                setInputValue('');
                }
                })
               }catch(err) {
                    console.error("Erreur lors du chargement de l'utilisateur :", err);
                }
    };

    useEffect(() => {  
      // _idCatQuery &&   setValues({ ...values, selCategories: true, AcCat:"active" });
       
       
      if (_idProdQuery) {
        loadProductsView(_idProdQuery);
        return;
      }
      if (_idCatQuery) {
        // Refresh / deep link on the Info step: only `ic` is in the URL, so
        // restore that category (and the Info step) instead of rendering an
        // empty wizard. Skipped when the category was just chosen in-page.
        String(categories?._id) !== String(_idCatQuery) && loadCategory(_idCatQuery);
        return;
      }
      loadCategory();
      // Only the URL drives this; the loaders are redefined every render.
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_idProdQuery, _idCatQuery]);

    useEffect(() => {
      if (!selCategories) return;
      wizardContentRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, [selCategories, inpProduct, filtProduct, imgPreview, categories?._id]);

    const seleteCategory = () => event => {
        const supcategory = event.target.value;
        if (supcategory){
        setValues({ ...values, catalogID: categories._id });
        loadCategory(supcategory)
    }else{
        loadCategory(elakayCategoryID)
    }
    }

    const selectAdress = () => event => {
        const IdAdress = event.target.value;  
        addressId(token, IdAdress)
    }

    const clickBack = (LA) => {
        loadCategory(LA)
    }
    
    const addressId = (token, adressId) => {

    adressId && ( 
          getAddressById(token, adressId).then(data => {
                if (data.error) { 
                    setAddressSelect()
                   
                } else {
                    setAddressSelect(data[0])
                }
            }))
    }

    const nameArrCat = (a, b)=>{
        let textfil  = "" 
        for (let i in a) {
            textfil  +=  a[i] + b + ' ' 
          }
          return textfil
    }
    
    const ButtonBackCategory = () => {
        
        let CategoryIDSEl = categories.categoryID && categories.categoryID?.length > 1 ? categories.categoryID[1] : category
        return (
            <span onClick={() => clickBack(CategoryIDSEl)} className="h5 float-left">
                <FaLongArrowAltLeft />
            </span>
        )
    }


//category by selection or category by name search

let listeCatSelSea = ['by selection', 'by name search']

const handleCatSelSea = (a)=>{
    if(a == 'by selection'){
        setcatSelectedSearch(true)
    }else if (a == 'by name search'){
        setcatSelectedSearch(false)
    }
}

const checkedSelSea = (a)=>{
    if(a){
    return 'by selection'
    }else{
    return 'by name search'
    }
}

const catSelSeaLabel = (ob)=>{
    return ob === 'by selection'
        ? __elakayText("t026", "by selection")
        : __elakayText("t027", "by name search")
}

const CheckingCat = ()=>{
    return <div className="form-group">
 <span  className="btn p-2"  onClick={() => clickButton2()}><GrClose/></span>
<h2>{catSelectedSearch && ButtonBackCategory()}{__elakayText("t004", "elakay categories")}</h2>
    { listeCatSelSea?.map((ob) =>{
return <React.Fragment key={ob}> <input
            className="form-check-input"
            onChange={()=>handleCatSelSea(ob)}
            checked={checkedSelSea(catSelectedSearch) == ob ? 'checked' : ''}
            type="radio"
            name="typeList"
            id={"typeList_" + ob}
            />
  <label className="form-check-label" htmlFor={"typeList_" + ob}>{catSelSeaLabel(ob)}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
    </React.Fragment>
})}
</div>

}

    // selcet categorie pour les vendre 
    const selectCategory = () => {

     return selCategories && <>
        {CheckingCat()}
       { catSelectedSearch ? <CatSelected
       clickBack={clickBack}
        clickButton2={clickButton2}
        ButtonBackCategory={ButtonBackCategory}
        seleteCategory={seleteCategory}
        laguangeElakay={laguangeElakay}
        infoSource={infoSource}
        categories={categories}
         /> : <CatSearch 
         infoSource={infoSource}
         search ={search}
         setSearch ={setSearch}
         setSearchInput={setSearchInput}
         searchInput={searchInput}
         getCategoriesByName={getCategoriesByName}
         categories={categories}
         loadCategory={loadCategory}
         />}
         {categoryValidationError && (
           <div className="alert alert-danger" role="alert">{categoryValidationError}</div>
         )}
         </>
    }


    const f1 = filters?.length > 0;
    const e1 = items?.length > 0;
    const categoryReady = isFinalSellerProductCategory(categories, items, filters);
    const Adr = address?.length
    const productTrue = name !== "" && price !== "" && description !== "" && condition !=="" && Boolean(addressSelect?._id || hasShopAddress)
  
    const clickButton =()=>{
        scrollToDiv(divSelCatego)
        setCategoryValidationError("");
        setValues((previous) => ({ ...previous, selCategories: true, AcCat:"active" }));
        // navigate(sellUrl)
    }
    const clickButton2 =(catID = elakayCategoryID)=>{
        loadCategory(catID)
        setValues(jsonValues)
        setValues({ ...values, selCategories: false, AcCat:"", AcInf:""});
        // navigate(sellUrl)
    }
    const clickButton3 =()=>{
        loadCategory(elakayCategoryID)
        setValues(jsonValues)
        setValues({ ...values, selCategories: false, AcCat:"",  AcInf:""});
    }
    const openInfoStep = () => {
      if (!categoryReady) {
        // Back from Info keeps the selected terminal category in `ic`.
        // Restore it instead of forcing the user to traverse the hierarchy
        // again; loadCategory performs the transition once it resolves.
        if (_idCatQuery && String(_idCatQuery) !== String(categories?._id)) {
          setCategoryValidationError("");
          loadCategory(_idCatQuery, true, {}, values);
          return;
        }
        setCategoryValidationError(
          elakayAutoText("h_addproduct_category_required", "Choose a final category with product filters before continuing.")
        );
        return;
      }
      setCategoryValidationError("");
      setValues((previous) => ({
        ...previous,
        selCategories: true,
        inpProduct: true,
        filtProduct: false,
        imgPreview: false,
        AcCat: "active",
        AcInf: "active",
        AcFilt: "",
        AcImg: "",
      }));
    };
    //add Or create product pour les vendre
    const clickSubAdd = event => {

     event.preventDefault();
        if (words?.length >= 0 && words?.length < 3) return setMaxkey(setMaxInputValue(code, 'minKeywords'));

        scrollToDiv(divProduct)
        setValues({ ...values, error: "", loading: true });
        createProduct(token, { boutiqueId: shopIds, name, description, costPrice, price, shipping, shippingPrice: shipping ? 0 : (Number(shippingPrice) || 0), addressShop: addressSelect?._id, keysProduct: words, condition, categoriesID}).then(data => {
            if (data.error) {
                setValues({ ...values, error: data.error });
            } else {


              // buildUrlWithSel(data, "ip")

              //  navigate(`${sellUrl}?sel=true&ip=${data._id}`)
        
                navigate(buildUrlWithSel(data, "ip"))
                setValues({
                    ...data,
                    inpProduct: false,
                    filtProduct: true,
                    AcFilt:"active",
                    productID: data._id,
                    // createdProduct: data.name,
                    // redirectToFilter: true
                    loading: loading,

                });
                // The product URL change loads the saved product once.

            }
        });
    };

     //update product pour les vendre
     const clickSubUpd = event => {
             event.preventDefault();
             if (words?.length >= 0 && words?.length < 3) return setMaxkey(setMaxInputValue(code, 'minKeywords'));
            setValues({ ...values, error: "", loading: true });
    
            updateProduct(token, productID, { boutiqueId: shopIds, email: userInfo.email , name, description, costPrice, price, shipping, shippingPrice: shipping ? 0 : (Number(shippingPrice) || 0),  graphic, creatorDesign, addressShop: addressSelect?._id, keysProduct: words}).then(data => {
                if (data.error) {
                    setValues({ ...values, error: data.error });
                } else {
                    setValues({
                        ...values,
                        inpProduct: false,
                        filtProduct: true,
                        productID: data.productID,
                        createdProduct: data.name,
                        // redirectToFilter: true
                        loading: false,
                    });
                    loadProductsView(productID)
                  
                }
            });
        };

        // `filId` (2e argument) : passé par AddFilterProduct.pageChange (voir
        // adfilterProduct.jsx), qui rappelle loadProductsView(catID, filId)
        // après avoir (dé)sélectionné un filtre -- même contrat que
        // editProduct.jsx:loadProductsView, pour pouvoir réutiliser
        // AddFilterProduct tel quel dès la création du produit.
        const loadProductsView = (productID, filId)  => {

            productID && getUserProductPreview(productID).then(data => {
                if (data.error) {
                    //  navigate(`${sellUrl}?sel=true`)
                } else {
                    setProductForShops(data.product);
                    setShopIds(data.product?.boutiqueId?.length ? data.product.boutiqueId.map((s) => String(s?._id || s)) : undefined);
                    const savedAddressId = data.product?.addressShop?._id || data.product?.addressShop;
                    savedAddressId && addressId(token, savedAddressId);
                    let catID = data?.product?.categoriesID?.length > 0 && data?.product?.categoriesID[0].catID ? data?.product?.categoriesID[0]?.catID?._id : elakayCategoryID
                    const savedFilters = Array.isArray(data.filterProduct) ? data.filterProduct : (data.product.filterProduct || []);
                    const selectedCategoryId = _idCatQuery || catID;
                    const categoryFilters = savedFilters.filter((row) => sellerCategoryId(row.catID) === String(selectedCategoryId));
                    const filtActive = categoryFilters.length > 0;
                    const filt = categoryFilters[0]?.filter || {};
                    setFilterProducts(savedFilters);



              _idCatQuery === null && loadCategory(catID, false, filt);
                setWords(data.product.keysProduct || []);
                setValues({
                    ...data.product,
                    inpProduct: false,
                    filtProduct: !filtActive,
                    imgPreview: filtActive,
                    selCategories: true,
                     AcCat:"active",
                     AcInf:"active",
                     AcFilt:"active",
                    AcImg: filtActive ? "active" : "",
                    quantity: filtActive ? categoryFilters[0].quantity : "",
                    catalogID : catID,
                    productID: data.product._id,
                    loading: loading,

                });
              _idCatQuery !== null && loadCategory(_idCatQuery, true, filt, data.product);

              setFilterSel(data.product.filters || []);
              if (filId) {
                const matched = (data.product.filters || []).find(item => item?._id?._id === filId);
                matched && setItemFilValue(matched);
              }
              getImages(productID).then(imgData => {
                !imgData?.error && setImagesProd(imgData);
              });
                }
            });
        };

    const handleChange = name => event => {
        const value = event.target.value;
        setProductValidationError("");
        setValues((previous) => ({ ...previous, error: false, [name]: value, categoriesID:[{catID: categories._id, name: categories.name, gategoriesLink: categories.categoryID}]}));
    };

    const parcelChange = name => event => {
        const value = event.target.value;
        setParcel({ ...parcel, [name]: value });
    };





    const LayoutImg = ({ input, previews, submitButtonContent, submitButton, dropzoneProps ,files, extra: { maxFiles } }) => {
        return (
            <div>
                {previews}
                {submitButtonContent}
                

                <div {...dropzoneProps}>
                    {files?.length < maxFiles && input}
                </div>

                {files?.length >= 0 && submitButton}
            </div>
        )
    }
  

const parcelForm = () =>( 
   
        <div>
            <h5>{infoSource.laguangeElakay('title', infoSource.languageAPI).dimensionWeight}</h5>
            <div className="form-group">
                <label className="text-muted">{infoSource.laguangeElakay('sellPage', infoSource.languageAPI)?.length}{__elakayText("t005", "(in)")}</label>
            <input onChange={parcelChange("length")} type="number" min="1" className="form-control" value={length} />
            </div>
            <div className="form-group">
                <label className="text-muted">{infoSource.laguangeElakay('sellPage', infoSource.languageAPI).width}{__elakayText("t005", "(in)")}</label>
            <input onChange={parcelChange("width")} type="number" min="1" className="form-control" value={width} />
            </div>
            <div className="form-group">
                <label className="text-muted">{infoSource.laguangeElakay('sellPage', infoSource.languageAPI).height}{__elakayText("t005", "(in)")}</label>
            <input onChange={parcelChange("height")} type="number" min="1" className="form-control" value={height} />
            </div>
            <div className="form-group" >
                <label className="text-muted">{infoSource.laguangeElakay('sellPage', infoSource.languageAPI).weight}{__elakayText("t006", "(lb)")}</label>
            <input onChange={parcelChange("weight")} type="number" min="1" className="form-control" value={weight} />
            </div>
        </div>

)

          const deleteWord = (indexToDelete, e) => {
            e.preventDefault();
     if (e.key === undefined) {
    setWords(words.filter((_, i) => i !== indexToDelete));
     }
  };

  const setMaxInputValue = (lang, type = 'minLength') => {
  const messages = {
    minLength: {
      fr: "Vous devez entrer plus de 3 caractères pour ajouter dans le keyword.",
      en: "You must enter more than 3 characters to add to the keyword.",
      ht: "Ou dwe antre plis pase 3 karaktè pou ajoute nan mo kle a.",
      pt: "Você deve digitar mais de 3 caracteres para adicionar à palavra-chave.",
      es: "Debe ingresar más de 3 caracteres para agregar a la palabra clave.",
    },
    minKeywords: {
      fr: "Vous devez ajouter un minimum de 3 mots-clés pour la recherche.",
      en: "You must add at least 3 keywords for searching.",
      ht: "Ou dwe ajoute omwen 3 mo kle pou rechèch la.",
      pt: "Você deve adicionar no mínimo 3 palavras-chave para a pesquisa.",
      es: "Debe agregar al menos 3 palabras clave para la búsqueda.",
    },
    maxKeywords: {
      fr: "Vous pouvez ajouter jusqu'à 9 mots-clés afin d’optimiser la visibilité de votre produit auprès des clients.",
      en: "You can add up to 9 keywords to improve your product’s visibility to customers.",
      ht: "Ou ka ajoute jiska 9 mo kle pou ogmante vizibilite pwodwi ou devan kliyan yo.",
      pt: "Você pode adicionar até 9 palavras-chave para aumentar a visibilidade do seu produto para os clientes.",
      es: "Puede añadir hasta 9 palabras clave para mejorar la visibilidad de su producto ante los clientes.",
    },
  };

  return (messages[type] && messages[type][lang]) || messages[type]?.en || "";
};

  const addWord = (e) => {
    e.preventDefault();
    if(inputValue?.length <= 3 && inputValue.trim() !== '') return setMaxkey(setMaxInputValue(code, 'minLength'));
    if (words?.length < 9 && inputValue?.length > 3) {
      setWords([...words, inputValue.trim()]);
      setInputValue('');
    }
  };

  const handleKeyDown = (e) => {

    if (e.key === 'Enter') {
        
        if(inputValue.trim() !== '' && words?.length < 9) return addWord(e);

    if(productTrue  &&  inputValue.trim() === ''){
        productID === '' ? clickSubAdd(e) : clickSubUpd(e);
    }
    }
  };
const calculateFontSize = (index, totalElements) => {
    const maxSize = 25;
    const minSize = 16;
    const sizeStep = (maxSize - minSize) / (totalElements - 1);
    return maxSize - (index * sizeStep);
  };


  const handLi = (obj = {}) => {
// filter = values.filtProduct?.length > 0 ? values.filtProduct[0].filter : {}
  setValues((previous) => ({ ...previous, ...obj}));
  };
  
    const newPostForm = () => (
        inpProduct && (
            
            <div>
                {/* {setValues({ ...values, AcInf:"active" })} */}
                 <span  className="btn p-2"  onClick={() => clickButton3()}><GrClose/></span>
                <div className="boxCategory1 text-center" id="heading">
                    <h2>{categories.name[0]} </h2>
                    {ButtonBackCategory()}   
                     <p>
      {Array.isArray(categories.name) && categories.name?.map((word, index) => (
      index !== 0 &&  <span 
          key={index} 
          style={{ fontSize: `${calculateFontSize(index, categories.name?.length)}px` }}
        >
          {word}{index < categories.name?.length - 1 ? ', ' : '.'}
        </span>
      ))}
    </p>
                    {showLoading()}
                    {showSuccess()}
                    {showError()}
                    {productValidationError && <div className="alert alert-danger" role="alert">{productValidationError}</div>}
                </div>
                <form className="mb-3" 
                  onSubmit={(e) => {
                e.preventDefault(); // ⛔ Empêche le rechargement de la page
                productID === '' ? clickSubAdd(e) : clickSubUpd(e);
                    }}
                >
                    <div className="form-group">
                        <label className="text-muted">{infoSource.laguangeElakay('sellPage', infoSource.languageAPI).name}</label>
                        <input
                        ref={nameRef}
                        onChange={handleChange('name')}
                        type="text" className="form-control"
                        value={name}
                        //  onPaste={handlePaste}
                         />
                        <small className="form-text text-muted">{elakayAutoText("h_addproduct_hint_name", "The product name buyers will see in search and on the product page")}</small>
                    </div>

                    <div className="form-group">
                        <label className="text-muted">{infoSource.laguangeElakay('sellPage', infoSource.languageAPI).description}</label>
                        <textarea
                        ref={descriptionRef}
                        onChange={handleChange('description')}
                        className="form-control"
                        value={description}
                        // onPaste={handlePaste}
                        />
                        <small className="form-text text-muted">{elakayAutoText("h_addproduct_hint_description", "Describe the product: materials, size, what's included, and anything a buyer should know")}</small>
                    </div>

                        <div className="p-4 max-w-xl mx-auto">
                          <label className="block mb-2 text-lg font-semibold text-gray-700">
                            {/* Add keywords for search to your product */}
                             {infoSource.language(infoSource, "label", "keyWordsSearch")}
                          </label>
                                <ErrorAlert error={getMaxkey} setError={setMaxkey} duration={10000} />
                          <div className="flex flex-wrap gap-2 items-center border border-gray-300 p-3 rounded">
                            {words?.map((word, index) => (
                        <div
                      key={index}
                      style={{
                        display: 'inline',
                        // width: '100px',
                        // height: '50px',
                        padding: '5px',
                        // border: '1px solid blue',
                        backgroundColor: '#F5F5F5',
                        margin: '5px',
                        // marginBottom: '20px',
                        textAlign: 'center',
                      }}
                    >
                      {word}
                      {/* <button
                        onClick={(e) => deleteWord(index, e)}
                        style={{ marginLeft: '5px', color: 'red', fontWeight: 'bold' }}
                      >
                        ×
                      </button> */}
                    
                      <MdDeleteForever 
                       onClick={(e) => deleteWord(index, e)}
                        style={{ marginLeft: '5px', fontWeight: 'bold', fontSize: '23px', cursor: 'pointer'}}
                      />
                    </div>
                            ))}
                    
                            {/* Input et bouton "+" en ligne avec les mots */}
                            {words?.length < 9 && (
                              <>
                                <input
                                  type="text"
                                  placeholder={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addProduct.t001}
                                  value={inputValue}
                                  onChange={(e) => setInputValue(e.target.value)}
                                  onKeyDown={handleKeyDown}
                                  className="inline-block border border-gray-400 px-2 py-1 rounded"
                                  style={{ minWidth: '150px' }}
                                />
                                <button
                                  onClick={(e)=>addWord(e)}
                                  className="inline-block bg-blue-500 px-2 py-1 rounded"
                                >
                               <MdAddCircle />
                                </button>
                              </>
                            )}
                          
                          </div>   
                          <span className="font-weight-light text-info">
                            {setMaxInputValue(code, 'maxKeywords')}
                        </span>
                        </div>

                    <div className="form-group">
                        <label className="text-muted">
                            {/* cost Price */}
                             {infoSource.language(infoSource, "label", "costPrice")}
                            </label>
                        <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">$</span>
                 </div>
                                <ProductPriceInput onChange={handleChange('costPrice')} placeholder="0.00" className="form-control" value={costPrice} />
                </div>
                        <small className="form-text text-muted">{elakayAutoText("h_addproduct_hint_costprice", "What you paid to acquire or make this product (used to calculate your profit)")}</small>
                    </div>

                    <div className="form-group">
                        <label className="text-muted">{infoSource.laguangeElakay('sellPage', infoSource.languageAPI).price}</label>
                        <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">$</span>
                 </div>
                                <ProductPriceInput ref={priceRef} onChange={handleChange('price')} placeholder="0.00" className="form-control" value={price} />
                </div>
                        <small className="form-text text-muted">{elakayAutoText("h_addproduct_hint_price", "The price buyers will pay for this product")}</small>
                    </div>
                    <div className="form-group">
                        <ProductShopSelector value={shopIds} onChange={setShopIds} />
                        <label className="text-muted">{infoSource.laguangeElakay('sellPage', infoSource.languageAPI).adressShop}</label>
                        <select ref={addressSelectRef} onChange={selectAdress()} className="form-control" value={addressSelect && addressSelect._id ? addressSelect._id: 0}>
                            <option value='0'>{infoSource.laguangeElakay('label',  infoSource.languageAPI).pleaseSelect}</option>
                            {
                                address?.map((Adre, i)=>(
                                    <option key={i} value={Adre._id}>({Adre.firstName} {Adre.lastName}) {Adre.Address1}, {Adre.city} {Adre.State} {Adre.postalCode} {Adre.country}</option>
                            ))
                            }
                        </select>
                        <small className="form-text text-muted">{elakayAutoText("h_addproduct_hint_addressshop", "The address this product ships from")}</small>
                    </div>
                    {/* <div className="form-group">
                        <label className="text-muted">{infoSource.laguangeElakay('sellPage', infoSource.languageAPI).freeShipping}</label>
                        <select onChange={handleChange('shipping')} className="form-control" value={shipping}>
                            <option value="" >{infoSource.laguangeElakay('label',  infoSource.languageAPI).pleaseSelect}</option>
                            <option value={false}>{infoSource.laguangeElakay('label',  infoSource.languageAPI).no} </option>
                            <option value={true}>{infoSource.laguangeElakay('label',  infoSource.languageAPI).yes}</option>
                        </select> 
                        <span className="font-weight-light text-info"> {infoSource.laguangeElakay('label',  infoSource.languageAPI).onChargeShipping}</span>
                    </div> */}

                  

                
                    {/* <div  className="form-group">
                        <label className="text-muted">{infoSource.laguangeElakay('sellPage', infoSource.languageAPI).graphicDesign} </label><br/>
                          <label className="switch">
                                <input 
                                    onChange={() => setValues({ ...values, graphic: !graphic })}
                                    type="checkbox" 
                                    checked={graphic ? 'checked' : ''}
                                />
                                <span className="slider round"></span>
                            </label> <br /> 
                        <span className="font-weight-light text-info"> {infoSource.laguangeElakay('text',  infoSource.languageAPI).graphicAddProduct}</span>
                    </div> */}

                    <div className="form-group">
                        <label className="text-muted">{infoSource.laguangeElakay('sellPage', infoSource.languageAPI).condition}</label>
                        <select ref={conditionRef} onChange={handleChange('condition')} className="form-control" value={condition}>
                            <option value="" >{infoSource.laguangeElakay('label',  infoSource.languageAPI).pleaseSelect}</option>
                            <option value="New">{infoSource.laguangeElakay('label',  infoSource.languageAPI).new}</option>
                            <option value="Used">{infoSource.laguangeElakay('label',  infoSource.languageAPI).used}</option>
                        </select>
                        <small className="form-text text-muted">{elakayAutoText("h_addproduct_hint_condition", "Whether this product is brand new or previously used")}</small>
                    </div>

                  <div  className="form-group">
                        <label className="text-muted">{infoSource.laguangeElakay('sellPage', infoSource.languageAPI).freeShipping}</label><br/>
                          <label className="switch">
                                <input 
                                    onChange={() => setValues({ ...values, shipping: !shipping })}
                                    type="checkbox" 
                                    checked={shipping ? 'checked' : ''}
                                />
                                <span className="slider round"></span>
                            </label> <br /> 
                         <span className="font-weight-light text-info"> {infoSource.laguangeElakay('label',  infoSource.languageAPI).onChargeShipping} <span  className="inline text-blue-600 underline cursor-pointer hover:text-blue-800 transition-colors duration-150" style={{color:'red', extDecoration: "underline", cursor: "pointer"}} onClick={()=>setSimulationSales(true)}>{infoSource.language(infoSource, "Button", "salesSimul")}</span></span>
                    </div>

                    {!shipping && (
                        <div className="form-group">
                            <label className="text-muted">{elakayAutoText("h_addproduct_shippingprice_label", "Shipping price")}</label>
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">$</span>
                                </div>
                                <input onChange={handleChange('shippingPrice')} type="number" min="0" step="0.01" placeholder="0.00" className="form-control" value={shippingPrice} />
                            </div>
                            <small className="form-text text-muted">{elakayAutoText("h_addproduct_hint_shippingprice", "The amount buyers will be charged for shipping this product")}</small>
                        </div>
                    )}

                    {/* <button className="btn btn-primary float-left"   onClick={() => clickButton3()}>{infoSource.laguangeElakay('Button', infoSource.languageAPI).cancel}</button> */}
                    {nextToSelection(productTrue, [
                        [name, nameRef, infoSource.laguangeElakay('sellPage', infoSource.languageAPI).name],
                        [description, descriptionRef, infoSource.laguangeElakay('sellPage', infoSource.languageAPI).description],
                        [price, priceRef, infoSource.laguangeElakay('sellPage', infoSource.languageAPI).price],
                        [condition, conditionRef, infoSource.laguangeElakay('sellPage', infoSource.languageAPI).condition],
                        [addressSelect?._id || hasShopAddress, addressSelectRef, infoSource.laguangeElakay('sellPage', infoSource.languageAPI).adressShop],
                    ])}
                </form>
            </div>
        ))

    const laadingGIf = () => (
        loading && (
            <div className="alert alert-info">
                <h2>
                    {/* Loading... */}
                    {infoSource.language(infoSource, "title", "loanding")}
                    </h2>

                <img src={Loader} className={`search-loading ${loading ? 'show' : 'hide'}`} alt={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addProduct.t002} />
                
            </div>
        )
    )
    const seleteFilterProduct = () => (
        filtProduct && (
            <>
                <div className="boxCategory1 text-center" id="heading">
                    <h2> {categories.name?.[0]} </h2>
                    {/* {categories.name?.map((c, i) => (<p className="d-inline" key={i} >{c}{" / "}</p>))} */}
                    <p>
                    {Array.isArray(categories.name) && categories.name?.map((word, index) => (
                    index !== 0 &&  <span 
                    key={index} 
                    style={{ fontSize: `${calculateFontSize(index, categories.name?.length)}px` }}
                    >
                    {word}{index < categories.name?.length - 1 ? ', ' : '.'}
                    </span>))}
                    </p>
                    
                    {showLoading()}
                    {showSuccess()}
                    {showError()}
                </div>
                <SellerFilterEditor editor={filterEditor} infoSource={infoSource} onContinue={continueToImages} />

                {/* "Filter for product View" / variant display settings
                    (AddFilterProduct) intentionally NOT shown here anymore --
                    Sell Your Product (this "create" flow) only ever offers
                    it in Edit Product from now on, never during creation. */}
            </>

        ))
 

    const imagePreviewS = () => (
        imgPreview && (
            <>
                <ImagesLoading
                    laguangeElakay={laguangeElakay}
                    infoSource={infoSource}
                    filterID ={filterID}
                    imgSize={0}
                    namProduct={name}
                    setValues={setValues}
                    values={values}
                    productIDEdit={productID}
                    setGetUrl={setGetUrl}
            />
                {/* <div className="boxCategory1 text-center" id="heading">
                    <h2> {categories.name} </h2>
                    {categoyseleted?.map((c, i) => (<p className="d-inline" key={i} >{c}{" / "}</p>))}
                    {showLoading()}
                    {showSuccess()}
                    {showError()}
                </div>
                <Dropzone
                    onChangeStatus={handleChangeStatus}
                    LayoutComponent={LayoutImg}
                    onSubmit={handleSubmit}
                    submitButtonContent={"ADD SELL"}
                    maxFiles={12}
                    maxSizeBytes={3000000}
                    inputWithFilesContent={files => `Add ${12 - files?.length} more or not`}
                    classNames={{ inputLabelWithFiles: defaultClassNames.inputLabel }}
                    inputContent="Drop your File or Click"
                    styles={{ dropzone: { minHeight: 250, maxHeight: 20, maxWidth: 250 }, previewImage: { minHeight: 180, minWidth: 180 }, inputLabel: { fontSize: 15 }, submitButton: { minHeight: 45, minWidth: 100, bordeRadius: 0, float: "right" } }}
                /> */}
              
            </>
        )
    )

    const checkProdKeyExit = (ad)=>{
        let ent 
        if(Array.isArray(ad)){
          let ac = ad[0]
          ent = Object.keys(ac ? ac:{});
          return ent.every(([key, val]) => ac[key] != undefined) && true
        } else{
           ent = Object.keys(ad ? ad:{});
           return ent.every(([key, val]) => ad[key] != undefined) && true
        }}


    const pageSteps = (a)=>{
            if (!checkProdKeyExit(a)){
               return <Pages  
                classAlert ={"container-fluid"}
                classText={elakayAutoText("h_54e188944c1637", "col col-11")}
                classImg={elakayAutoText("h_34cf7f05bfb152", "col col-10")}
                classPara={elakayAutoText("h_71235f02727ebb", "row justify-content-center")}
                paragra0={a}
            />
            }else{
              return <div> 
              <div className="row mt-4 mb-4 justify-content-center">
              <img className="shadow-lg" style={{ width: "100%" }} src={nodata} alt={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addProduct.t003} />
               </div>
               </div>
            }
        }

    const stepSeller = ()=>(
        // <div className="boxCategory1 text-center">
   <div className="row">
  <div className="col-xs-12 col-md-8 offset-md-2 block pb-4">
    <div className="wrapper-progressBar">
        <h2>{infoSource.laguangeElakay('title',  infoSource.languageAPI).sellingProduct}</h2>
      <ul className="progressBar" aria-busy={filterEditor.savingFilterCombinations} onClickCapture={(event) => {
        if (filterEditor.savingFilterCombinations) { event.preventDefault(); event.stopPropagation(); }
      }}>
        <li className={AcCat} onClick={()=> {loadCategory(elakayCategoryID); setCategoryValidationError(""); setValues((previous) => ({ ...previous, selCategories: true, inpProduct: false, filtProduct: false, imgPreview: false, AcCat:"active", AcInf:"", AcFilt: "", AcImg:"" }))}} >{infoSource.laguangeElakay('title',  infoSource.languageAPI).Categories}</li>
        <li className={AcInf} onClick={openInfoStep}>{infoSource.laguangeElakay('Button', infoSource.languageAPI).info}</li>
        <li className={AcFilt} onClick={()=>{ productTrue && handLi({
                    selCategories: true, 
                    inpProduct: false,
                    filtProduct: true,
                    imgPreview: false,
                    AcCat:"active",
                    AcInf:"active", 
                    AcFilt: "active",
                    AcImg: ""}); _idCatQuery !== null && loadCategory(_idCatQuery, true, {}, values) }}>{infoSource.laguangeElakay('title',  infoSource.languageAPI).filters}</li>
        <li className={AcImg} onClick={continueToImages}>{infoSource.laguangeElakay('title', infoSource.languageAPI).images}</li>
      </ul>
    </div>
  </div>
</div>
        // </div>
    )
    const lightColors = [
        { name: __elakayText("t008", "White"), hex: "#FFFFFF" },
        { name: __elakayText("t009", "Snow"), hex: "#FFFAFA" },
        { name: __elakayText("t010", "Honeydew"), hex: "#F0FFF0" },
        { name: __elakayText("t011", "MintCream"), hex: "#F5FFFA" },
        { name: __elakayText("t012", "GhostWhite"), hex: "#F8F8FF" },
        { name: __elakayText("t013", "Ivory"), hex: "#FFFFF0" },
        { name: __elakayText("t014", "FloralWhite"), hex: "#FFFAF0" },
        { name: __elakayText("t015", "Seashell"), hex: "#FFF5EE" },
        { name: __elakayText("t016", "Gainsboro"), hex: "#DCDCDC" },
        { name: __elakayText("t017", "LightGray"), hex: "#D3D3D3" },
        { name: __elakayText("t018", "AliceBlue"), hex: "#F0F8FF" },
        { name: __elakayText("t019", "Azure"), hex: "#F0FFFF" }
    
    ];
    
    const ColorDisplay = () => {
        return (
            <div>
                <h1 style={{ textAlign: "center", marginBottom: "20px", color: "#333" }}>{__elakayText("t007", "Color Background Authorized")}</h1>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", justifyContent: "center" }}>
                    {lightColors?.map((color) => (
                        <div
                            key={color.hex}
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "40px",
                                height: "40px",
                                backgroundColor: color.hex,
                                color: color.hex === "#FFFFFF" ? "#000" : "#FFF", // Adjust text color for better visibility
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                textAlign: "center",
                                fontSize: "10px",
                                overflow: "hidden"
                            }}
                            title={color.name} // Tooltip for full name
                        >
                            <span>{color.name}</span>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    const StartSelling =()=>(
        !selCategories && (
        <>
        <div className="accordion accordion-flush" id="accordionFlushExample">
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingOne">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
        <span className="circleSelling">1</span>  {infoSource.laguangeElakay('helpContact', infoSource.languageAPI).termsCondition} 
      </button>
    </h2>
    <div id="flush-collapseOne" className="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
        {pageSteps(infoSource.laguangeElakay('termConditProdSel',  infoSource.languageAPI))}
          <ul>
            <li><Link to="#" onClick={() => setConditions(true)}>{infoSource.laguangeElakay('helpContact', infoSource.languageAPI).termsCondition}</Link></li>
            <li><Link to="/help-contact" >{infoSource.laguangeElakay('helpContact', infoSource.languageAPI).HelpContact}</Link></li>
        </ul>
        </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingTwo">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
      <span className="circleSelling">2</span>  {infoSource.laguangeElakay('title',  infoSource.languageAPI).Categories}  {infoSource.laguangeElakay('title',  infoSource.languageAPI).ForSellingProduct} 
      </button>
    </h2>
    <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
      {pageSteps(infoSource.laguangeElakay('catalogProdSel',  infoSource.languageAPI))}
        </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingThree">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
      <span className="circleSelling">3</span>  {infoSource.laguangeElakay('Button', infoSource.languageAPI).info}  {infoSource.laguangeElakay('title',  infoSource.languageAPI).ForSellingProduct} 
      </button>
    </h2>
    <div id="flush-collapseThree" className="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">

      <div className="accordion-body">
      {pageSteps(infoSource.laguangeElakay('infoProdSel',  infoSource.languageAPI))}
       </div>
    
    </div>
  </div>

  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-heading04">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse04" aria-expanded="false" aria-controls="flush-collapse04">
      <span className="circleSelling">4</span>  {infoSource.laguangeElakay('title',  infoSource.languageAPI).filters}  {infoSource.laguangeElakay('title',  infoSource.languageAPI).ForSellingProduct} 
      </button>
    </h2>
    <div id="flush-collapse04" className="accordion-collapse collapse" aria-labelledby="flush-heading04" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
      {pageSteps(infoSource.laguangeElakay('filterProdSel',  infoSource.languageAPI))}
        </div>
    </div>
  </div>

  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-heading05">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse05" aria-expanded="false" aria-controls="flush-collapse05">
      <span className="circleSelling">5</span>  {infoSource.laguangeElakay('title',  infoSource.languageAPI).images} {infoSource.laguangeElakay('title',  infoSource.languageAPI).ForSellingProduct} 
      </button>
    </h2>
    <div id="flush-collapse05" className="accordion-collapse collapse" aria-labelledby="flush-heading05" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
      {pageSteps(infoSource.laguangeElakay('imageProdSel',  infoSource.languageAPI))}
      {ColorDisplay()}
        </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-heading06">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse06" aria-expanded="false" aria-controls="flush-collapse06">
      <span className="circleSelling">6</span>
      {/* All you have to Know about shipping. */}
      {infoSource.language(infoSource, "Button", "allAboutShip")}
      </button>
    </h2>
    <div id="flush-collapse06" className="accordion-collapse collapse" aria-labelledby="flush-heading06" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
         <ShippingTable
         infoSource={infoSource}
         />
     
        </div>
    </div>
  </div>
</div>
<div className="row justify-content-center">
<div className="bg clearfix ">
        <button className="btn btn-primary pt-2 pb-2 pr-3 pl-3 rounded-4 float-left"   onClick={() =>{clickButton()}}>{infoSource.laguangeElakay('Button', infoSource.languageAPI).getStarded}</button>
        <button className="btn btn-primary pt-2 pb-2 pr-3 pl-3 rounded-4 float-right"   onClick={()=>setSimulationSales(true)}>
            {/* sales simulation */}
            {infoSource.language(infoSource, "Button", "salesSimul")}
            </button>
            </div></div>
    </>
        )
    )
    const scrollToFirstMissing = (missingFields) => () => {
        const missing = missingFields.find(([value]) => !value);
        if (missing) {
            setProductValidationError(
              elakayAutoText("h_addproduct_required_field", "Complete the required field: {value0}", { value0: missing[2] })
            );
        }
        if (missing && missing[1]?.current) {
            missing[1].current.scrollIntoView({ behavior: "smooth", block: "center" });
            missing[1].current.focus?.();
        }
    };

    const nextToSelection = (activeBtnSelection, missingFields = []) => (
        activeBtnSelection ? (
            <button className="btn btn-primary float-right">{infoSource.laguangeElakay('Button', infoSource.languageAPI).next}</button>
        ) : (
        <button type="button" onClick={scrollToFirstMissing(missingFields)} className="btn btn-secondary float-right">{infoSource.laguangeElakay('Button', infoSource.languageAPI).next}</button>
      )
    )
    const showError = () => (
        <div
            className="alert alert-danger"
            style={{ display: error ? "" : "none" }}
        >
            {error}
        </div>
    );

    const redicectToFilters = () => (
        <Modal
            show={redirectToFilter}
            onHide={() => setValues({ ...values, redirectToFilter: false })}
            centered
            aria-labelledby="add-success-modal-title"
            contentClassName="add-success-modal"
        >
            <span
                className="btn p-2 add-success-close"
                onClick={() => setValues({ ...values, redirectToFilter: false })}
            >
                <GrClose />
            </span>
            <div className="add-success-body">
                <div className="add-success-icon"><FaCheckCircle /></div>
                <h3 id="add-success-modal-title" className="add-success-title">
                    {__elakayText("t022", "Le produit a été ajouté avec succès.")}
                </h3>
                <p className="add-success-question">{__elakayText("t023", "Voulez-vous continuer ?")}</p>
                <div className="add-success-actions">
                    <button
                        type="button"
                        className="btn btn-primary add-success-btn"
                        onClick={() => {
                            setValues({ ...values, redirectToFilter: false });
                            navigate("/myshop?tab=sell-center");
                        }}
                    >
                        <MdAddCircle /> {__elakayText("t024", "Ajouter d'autres produits")}
                    </button>
                    <button
                        type="button"
                        className="btn btn-secondary add-success-btn"
                        onClick={() => {
                            setValues({ ...values, redirectToFilter: false });
                            navigate(getUrl);
                        }}
                    >
                        <FaEdit /> {__elakayText("t025", "Continuer à modifier ce produit")}
                    </button>
                </div>
            </div>
        </Modal>
    )

    const showSuccess = () => (
        <div
            className="alert alert-info"
            style={{ display: createdProduct ? "" : "none" }}
        >
            <h2>{`${createdProduct}`} 
                {/* is created! */}
                {infoSource.language(infoSource,  "title", "iscreated")}
                </h2>
        </div>
    );

    const showLoading = () =>
        loading && (
            <div className="alert alert-success">
                <h2>
                    {/* Loading... */}
                    {infoSource.language(infoSource, "title", "loanding")}
                    </h2>
            </div>
        );


    const AddTermsAndConditions = () => (
        <div className="contaire">
            <div className="row justify-content-center " >
                <Modal
                    size="lg"
                    show={showConditions}
                    onHide={() => setConditions(false)}
                    dialogClassName="modal-90w"
                    aria-labelledby="example-custom-modal-styling-title"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="example-custom-modal-styling-title">
                            <h2 className="text-center">{infoSource.laguangeElakay('helpContact', infoSource.languageAPI).termsCondition}</h2>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {TermsConditions()}
                        {ReturnAndRefundPolicy()}
                        {ContactUs()}
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    )


    const simulationSalesPage =()=>{
        return <Modal
        size="xl"
        show={shwoSimulationSales}
        onHide={() => setSimulationSales(false)}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        centered
    >
        <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
                <h2 className="text-center"> 
                    {/* Sales Simulation */}
                    {infoSource.language(infoSource, "Button", "salesSimul")}
                </h2>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <SalesSimulation
            infoSource={infoSource}
            laguangeElakay={laguangeElakay}
            search ={search}
            setSearch ={setSearch}
            setSearchInput={setSearchInput}
            searchInput={searchInput}
            getCategoriesByName={getCategoriesByName}
            categories={categories}
            loadCategory={loadCategory}
            token={token}
            />
          
        </Modal.Body>
    </Modal>
    }

    return (
        <>
        {stepSeller()}
            <div className="row " >
            <div ref={wizardContentRef} className="col-md-8 offset-md-2 blockEl">

            {laadingGIf()}
            {(e1?
                <>
                    
                    {( 
                                Adr? 
                                <>
                               <div ref={divSelCatego}>{selectCategory()}</div> 
                                {StartSelling()}
                                </>
                        :
                        <>
                                        <div className="row = justify-content-center">
                                            <div className="col-11 col-md-10 col-lg-9 col-xl-8">
                                                <div className="shadow-lg mt-3 mb-3">
                                                <img
                                                    className="rounded"
                                                    src={AddressSeller}
                                                    alt={__elakayText("t020", "no Product")}
                                                    style={{ height: "100%", width: "100%" }}
                                                />
                                            </div>
                                        </div>
                                        </div>
                            <Link to={"/profile?addr=true"}>
                                            <button className="btn btn-info float-right pt-2 pb-2 pr-3 pl-3">
                                 <span style={{ fontSize: "20px", paddingRight: "6px" }}><FaAddressCard /></span>{infoSource.laguangeElakay('Button', infoSource.languageAPI).addAdress}
                                </button>
                            </Link>
                        </>
                    )}
                           
                </>
                :
                        categoryReady ?
                   <div ref={divProduct}> 
                    {newPostForm()} 
                    {seleteFilterProduct()} 
                   {imagePreviewS()}
                   </div>
                :
                <div>
                    <span  className="btn p-2"  onClick={() => clickButton2()}><GrClose/></span>
                <div className="row = justify-content-center">
                <div className="col-11 col-md-10 col-lg-9 col-xl-8">
                 <div className="shadow-lg mt-3 mb-3">
                              <img
                                className="rounded"
                                src={CategoriesFilter}
                                alt={__elakayText("t020", "no Product")}
                                style={{ height: "100%", width: "100%" }}
                                />
                    </div>
                </div>
                </div>
                </div>
            )}
                   
            </div>
            </div>
            { e1 && (
                <div className="row = justify-content-center">
                    <div className="col-11 col-md-10 col-lg-9 col-xl-8">
                        <div className="shadow-lg mt-3 mb-3">
                        <img
                            className="rounded"
                            src={SellerPub}
                            alt={__elakayText("t021", "Seller Pub")}
                            style={{ height: "100%", width: "100%" }}
                        />
                    </div>
                </div>
                </div>
            )}
            { f1 && (
                <div className="row = justify-content-center">
                    <div className="col-11 col-md-10 col-lg-9 col-xl-8">
                        <div className="shadow-lg mt-3 mb-3">
                        <img
                            className="rounded"
                            src={Seller_caribbean}
                            alt={__elakayText("t020", "no Product")}
                            style={{ height: "100%", width: "100%" }}
                        />
                    </div>
                </div>
                </div>
             ) }
        
       {AddTermsAndConditions()}
     {redicectToFilters()}
     {simulationSalesPage()}
</>
    );
};

export default Sell;
